import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import DropDown from '../CategoryPicker/DropDown';
import theme from '../../styles/theme';
import get from '../../helpers/get';
import MaybeSwiper from '../Scrollers/MaybeSwiper';
import Button from '../CategoryPicker/Button';

export const tabTheme = {
  light: {
    foregroundColor: theme.colors.brand01,
    backgroundColor: theme.colors.white,
    backgroundTransparentColor: theme.colors.whiteOpacity0,
    disabledColor: theme.colors.ui02,
  },
  dark: {
    foregroundColor: theme.colors.brand01,
    backgroundColor: theme.colors.brandBlack,
    backgroundTransparentColor: theme.colors.darkOpacity0,
    disabledColor: theme.colors.lightText,
  },
};

class Tabs extends Component {
  componentDidUpdate() {
    const { selectedIndex } = this.props;
    if (this.swiper) {
      this.swiper.update();
      this.swiper.slideTo(selectedIndex);
    }
  }

  onClick = index => () => {
    const { onTabClicked } = this.props;
    if (onTabClicked) {
      onTabClicked(index);
    }
  };

  onChange = title => {
    const { tabs, onTabClicked } = this.props;
    if (onTabClicked) {
      onTabClicked(tabs.map(tab => tab.title).indexOf(title));
    }
  };

  setSwiperRef = ref => {
    this.swiper = ref;
  };

  render() {
    const {
      classes, tabs, navBarStyle,
      // eslint-disable-next-line react/prop-types
      selectedIndex, tabTheme: { disabledColor, foregroundColor },
    } = this.props;
    const selectedText = get(tabs, [selectedIndex, 'title']);
    const showTabs = navBarStyle && navBarStyle === 'Tabs on Desktop, Drop Down on mobile';

    return (
      <div className={classes.root}>
        <DropDown
          className={cn(classes.dropDown, { showTabs })}
          options={tabs.map(tab => tab.title)}
          selected={selectedText}
          onChange={this.onChange}
          buttonTheme={{
            color: disabledColor,
            selected: foregroundColor,
          }}
        />
        {showTabs && (
          <div className={classes.container}>
            <MaybeSwiper
              classNames={classes}
              slideClassName={classes.tab}
              longSwipesRatio={0.25}
              prevNextButtons={false}
              slidesPerView="auto"
              buttonColor={foregroundColor}
              swiperRef={this.setSwiperRef}
            >
              {tabs.map((tab, i) => (
                <Button
                  key={tab.title}
                  className={classes.tab}
                  selected={i === selectedIndex}
                  buttonTheme={{
                    color: disabledColor,
                    selected: foregroundColor,
                  }}
                  text={tab.title}
                  onClick={this.onClick(i)}
                  largePadding
                />
              ))}
            </MaybeSwiper>
          </div>
        )}
      </div>
    );
  }
}

Tabs.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  onTabClicked: PropTypes.func,
  selectedIndex: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types
  tabTheme: PropTypes.shape({
    foregroundColor: PropTypes.string,
    backgroundColor: PropTypes.string,
  }),
  navBarStyle: PropTypes.string,
};

Tabs.defaultProps = {
  onTabClicked: undefined,
  selectedIndex: 0,
  tabTheme: tabTheme.light,
  navBarStyle: undefined,
};

export default injectSheet({
  root: {
    marginBottom: 32,
    alignItems: 'center',
  },
  dropDown: {
    display: 'block',
    '&.showTabs': {
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  },
  container: {
    flex: '1 1 auto',
    position: 'relative',
    marginRight: 0,
    overflow: 'hidden',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  tab: {
    textTransform: 'uppercase',
    outline: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    '&:before': {
      content: '""',
      left: 0,
      right: 0,
      bottom: '-2px',
      position: 'absolute',
    },
  },
  content: {
  },
  button: {
    position: 'absolute',
    right: 16,
    top: 0,
    height: 'calc(100% - 3px) !important',
    borderRadius: '0 !important',
  },
})(Tabs);
